import React, { Component } from "react";
import DynamicTableComponentNew from "../../../Components/DynamicTableComponentsNew";
import constants from "../../../Utils/constants";
import { MasterServices } from "../../../Services/Master";
import ComapnyDetailsDateTimeFormatter from "../../../Utils/ComapnyDetailsDateTimeFormatter";
import Search from "../../../Components/Search";
import { connect } from "react-redux";
import CustomReactTooltip from "../../../Components/CustomReactTooltip";
import AclAction from "../../../Components/ACL/AclAction";
import Slugify from "../../../Utils/Slugify";
import DialogNew from "../../../Components/DialogNew";
import Toast from "../../../Utils/Toast";
import ManageMasterData from "../../../Containers/ManageMasterData";
import isRole_Acc_mgr_or_salesAdmin from "../../../Utils/isRole_Acc_mgr_or_salesAdmin";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
const tableHeader = [
  {
    id: "name",
    title: "name",
    sortable: true,
    headerStyle: { textTransform: "capitalize", textAlign: "left" },
    rowStyle: {
      textTransform: "capitalize",
      textAlign: "left",
    },
    visibility: true,
  },
  {
    id: "priority",
    title: "Priority",
    sortable: true,
    headerStyle: { textTransform: "capitalize", textAlign: "left" },
    rowStyle: { textTransform: "capitalize", textAlign: "left" },
    visibility: true,
  },
  {
    id: "created_by",
    title: "Created By",
    sortable: false,
    headerStyle: { textTransform: "capitalize", textAlign: "left" },
    rowStyle: { textTransform: "capitalize", textAlign: "left" },
    visibility: true,
  },
  {
    id: "created_at",
    title: "Created On",
    sortable: true,
    headerStyle: { textAlign: "left" },
    rowStyle: { textAlign: "left" },
    visibility: true,
  },
  {
    id: "is_active",
    title: "Status",
    sortable: true,
    headerStyle: {},
    rowStyle: { textAlign: "center" },
    headerClass: "text-center",
    visibility: true,
  },
  {
    id: "actions",
    title: "Actions",
    sortable: false,
    headerStyle: {},
    rowStyle: { textAlign: "center" },
    headerClass: "text-center",
    rowClass: "",
    visibility: true,
  },
];
const showActions = false;
class ListMetricTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      sortColumn: constants.PAGINATION.DEFAULT_SORT_COLUMN,
      sortOrder: constants.PAGINATION.DEFAULT_SORT_ORDER,
      pageNo: this.props.pageNo,
      pageSize: this.props.pageSize,
      name: "",
      documentModal: false,
      apiError: null,
      formErrors: {},
      isFormSubmitted: false,
      dialogModal: false,
      dialogModalContent: "",
      dialogModalHeader: "",
      dialogModalConfig: {},
      dialogModalStyleType: "",
      currentPageDataCount: 0,
      disableStatus: false,
      id: null,
      metricType: "",
      metricTypePriority: "",
    };
  }
  componentDidMount() {
    this.getTableData();

    const index = tableHeader.findIndex(element => element.id === "actions");
    const isRestrictedRole = isRole_Acc_mgr_or_salesAdmin(this.props.home.loginUserSuccess.role_id);

    if (index > -1) {
      tableHeader[index].visibility = !isRestrictedRole;
    }

    if (isRestrictedRole) {
      this.setState({ disableStatus: true });
    }
  }

  // Pagination Handlers
  pagePrevious = () => {
    this.setState(prevState => ({ pageNo: prevState.pageNo - 1 }), this.getTableData);
  };

  pageNext = () => {
    this.setState(prevState => ({ pageNo: prevState.pageNo + 1 }), this.getTableData);
  };

  handlePage = input => {
    this.setState({ pageNo: input }, this.getTableData);
  };

  handlePageSize = e => {
    this.setState({ pageSize: e.target.value, pageNo: 1 }, this.getTableData);
  };

  // Search & Sort Handlers
  handleSort = (clickedColumn, key) => {
    this.setState(
      prevState => ({
        sortColumn: clickedColumn,
        segmentSort: false,
        sortOrder: prevState.sortOrder === "desc" ? "asc" : "desc",
      }),
      this.getTableData,
    );
  };

  handleSearch = () => {
    this.setState({ pageNo: 1 }, this.getTableData);
  };

  handleInput = e => {
    this.setState({ name: e.target.value });
  };

  // Modal Handlers
  addMetricType = () => this.setState({ id: null, metricType: "", metricTypePriority: "", documentModal: true });

  closeDocumentModal = () => this.setState({ documentModal: false });

  // Confirm Activation/Deactivation Toggle Modal
  toggleMetricTypeConfirmationHandler = data => {
    const isActive = data.is_active === true || data.is_active === 1;

    this.setState({
      dialogModal: true,
      dialogModalHeader: (
        <h3 className="text-darkblue2 font-weight-bold">{isActive ? "De-Activation" : "Activation"}</h3>
      ),
      dialogModalContent: (
        <div className={isActive ? "remove-body" : "activate-body"}>
          <h2 className="font-weight-semibold mb-0">
            {isActive
              ? constants.MASTER_DATA_METRIC_TYPE.INACTIVATE_METRIC_TYPE_CONFIRM_MESSAGE
              : constants.MASTER_DATA_METRIC_TYPE.ACTIVATE_METRIC_TYPE_CONFIRM_MESSAGE}
          </h2>
        </div>
      ),
      dialogModalConfig: {
        type: isActive ? "de-activate_metric_type" : "activate_metric_type",
        id: data.id,
      },
      dialogModalStyleType: isActive ? "danger-modal" : "success-modal",
    });
  };

  // Toggle Active/Inactive status API handler
  toggleMetricType = (id, isActive) => {
    MasterServices.activeInactiveMetricType(id, { is_active: isActive })
      .then(() => {
        Toast(
          isActive
            ? constants.MASTER_DATA_METRIC_TYPE.ACTIVATE.SUCCESS
            : constants.MASTER_DATA_METRIC_TYPE.IN_ACTIVATE.SUCCESS,
          "success",
        );
        this.getTableData();
      })
      .catch(error => {
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  // Modal Action Confirm/Decline
  dialogModalAccept = ({ type, id }) => {
    this.setState({
      dialogModal: false,
      dialogModalHeader: "",
      dialogModalContent: "",
      dialogModalConfig: {},
    });

    if (type === "de-activate_metric_type") this.toggleMetricType(id, 0);
    else if (type === "activate_metric_type") this.toggleMetricType(id, 1);
  };

  dialogModalDecline = () => {
    this.setState({
      dialogModal: false,
      dialogModalHeader: "",
      dialogModalContent: "",
      dialogModalConfig: {},
    });
  };

  // Table Data Fetching
  getTableData = () => {
    const { sortOrder, sortColumn, name, pageNo, pageSize } = this.state;
    let queryParams = "";

    if (sortOrder) queryParams += `&sort_order=${sortOrder}&sort_column=${sortColumn}`;
    if (name) queryParams += `&search_column=name&search_value=${name}`;
    if (this.props.selectedTab) queryParams += `&selected_tab=${this.props.selectedTab}`;

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?page=${pageNo}&page_size=${pageSize}${queryParams}`,
    });

    MasterServices.getTotalMetricTypes(`metrics/list?level=1&page=${pageNo}&page_size=${pageSize}${queryParams}`)
      .then(res => {
        const rows = res.data.data.rows || [];
        const count = res.data.data.count || 0;

        const mappedData = rows.map(data => {
          const isActive = data.is_active === true || data.is_active === 1;

          return {
            id: data.id,
            name: data.name || "-",
            priority: data.priority || "-",
            created_by: data.created_by_user
              ? `${data.created_by_user.first_name} ${data.created_by_user.last_name}`
              : "-",
            created_at: ComapnyDetailsDateTimeFormatter(data.created_at || new Date(), false),
            is_active: (
              <AclAction
                type={constants.ACL.PERMISSION_KEY}
                entity={constants.ACL.METRIC_TYPE_RESOURCE.TITLE}
                action={constants.ACL.METRIC_TYPE_RESOURCE.ACTIONS.STATUS}
              >
                <div className="custom-control custom-switch success-toggle">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id={`customSwitch${data.id}`}
                    checked={isActive}
                    onChange={e => {
                      e.stopPropagation();
                      this.rowAction(constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.STATUS, data, e);
                    }}
                    disabled={this.state.disableStatus}
                  />
                  <label className="custom-control-label" htmlFor={`customSwitch${data.id}`} />
                </div>
              </AclAction>
            ),
            actions: this.getActions(data),
          };
        });

        this.setState({
          rowData: mappedData,
          count,
          currentPageDataCount: rows.length,
          documentModal: false,
        });
      })
      .catch(error => {
        this.setState({ rowData: [], count: 0, documentModal: false });
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  // Action Column UI
  getActions = data => (
    <>
      <AclAction
        type={constants.ACL.PERMISSION_KEY}
        entity={constants.ACL.METRIC_TYPE_RESOURCE.TITLE}
        action={constants.ACL.METRIC_TYPE_RESOURCE.ACTIONS.LIST}
      >
        <button
          tbrentitytype={constants.ACL.ENTITY_TYPE.BUTTON}
          onClick={e =>
            this.rowAction(constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.EDIT_METRIC_TYPE, data, e)
          }
          id={`tooltip-${Slugify(
            constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.EDIT_METRIC_TYPE_TOOLTIP,
          )}-${data.id}`}
          className="dynamicTableActionButton btn btn-md d-inline-flex align-items-center"
          data-tip={constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.EDIT_METRIC_TYPE_TOOLTIP}
          data-for={`tooltip-${Slugify(
            constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.EDIT_METRIC_TYPE_TOOLTIP,
          )}-${data.id}`}
          data-iscapture="true"
        >
          <span className="material-icons-outlined text-blue-clr icon-fs-21">edit</span>
        </button>
      </AclAction>
      <AclAction
        type={constants.ACL.PERMISSION_KEY}
        entity={constants.ACL.METRIC_TYPE_RESOURCE.TITLE}
        action={constants.ACL.METRIC_TYPE_RESOURCE.ACTIONS.LIST}
      >
        <button
          tbrentitytype={constants.ACL.ENTITY_TYPE.BUTTON}
          data-for={`tooltip-${Slugify(
            constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.MANAGE_METRICS_TOOLTIP,
          )}-${data.id}`}
          onClick={e => {
            this.rowAction(constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.MANAGE_METRICS, data, e);
          }}
          className={"dynamicTableActionButton btn btn-md d-inline-flex align-items-center"}
          data-tip={constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.MANAGE_METRICS_TOOLTIP}
          data-iscapture="true"
        >
          <span className="material-icons-outlined text-blue-clr icon-fs-21">menu</span>
        </button>
      </AclAction>
    </>
  );

  // Handle Edit/Add Submission
  handleSubmit = data => {
    const apiMethod = this.state.id ? "updateMetricsType" : "addMetricsType";

    MasterServices[apiMethod]({
      name: data.name,
      id: this.state.id,
    })
      .then(() => {
        Toast(constants.MASTER_DATA_METRIC_TYPE[this.state.id ? "EDIT" : "CREATE"].SUCCESS, "success");
        this.getTableData();
        this.setState({ id: null, metricType: "" });
      })
      .catch(error => {
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  manageMetricTypes = data => {
    this.props.gotoMetrics({
      metric_type_id: data.id,
    });
  };

  // General Row Action Handler
  rowAction = (action, data, e) => {
    e.stopPropagation();
    switch (action) {
      case constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.STATUS:
        this.toggleMetricTypeConfirmationHandler(data);
        break;
      case constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.EDIT_METRIC_TYPE:
        this.editMetricType(data);
        break;
      case constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.MANAGE_METRICS:
        this.manageMetricTypes(data);
        break;
      default:
        break;
    }
  };

  // Edit Handler
  editMetricType = data => {
    this.setState({
      documentModal: true,
      metricType: data.name,
      id: data.id,
      metricTypePriority: data.priority,
    });
  };

  // Handle Edit/Add Submission
  handleSubmit = () => {
    if (!this.state.metricType) {
      this.setState({ formErrors: { metricTypeError: true } });
      return;
    }
    const apiMethod = this.state.id ? "updateMetricsType" : "addMetricsType";

    MasterServices[apiMethod]({
      name: this.state.metricType,
      priority: this.state.metricTypePriority,
      id: this.state.id,
    })
      .then(() => {
        Toast(constants.MASTER_DATA_METRIC_TYPE[this.state.id ? "EDIT" : "CREATE"].SUCCESS, "success");
        this.getTableData();
        this.setState({ id: null, metricType: "" });
      })
      .catch(error => {
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  render() {
    return (
      <>
        <div className="d-flex justify-content-between">
          <div className="mb-3 position-relative">
            <div className="border-search search-box-shadow-2">
              <Search
                handleSearch={this.handleSearch}
                handleInput={this.handleInput}
                value={this.state.name}
                placeHolder={"Filter Metric Type"}
              />
            </div>
          </div>
          <button className="btn btn-custom btn-primary mb-3" type="button" onClick={this.addMetricType}>
            + Create New
          </button>
        </div>

        <div className="custom-table-block custom-table-block-2 first-col-fixed-block nowrap-table-block th-nowrap sort-table-block center-th-align">
          <DynamicTableComponentNew
            columnData={tableHeader}
            rowData={this.state.rowData}
            pagePrevious={this.pagePrevious}
            pageNext={this.pageNext}
            pageSize={this.state.pageSize}
            pageNo={this.state.pageNo}
            handlePage={this.handlePage}
            handleSort={this.handleSort}
            sortColumn={this.state.sortColumn}
            sortOrder={this.state.sortOrder}
            count={this.state.count}
            rowAction={this.rowAction}
            colSpan={tableHeader.filter(h => h.visibility).length}
            showActions={showActions}
            showPagination={true}
            paginationClass={"center-pagination custom-pagination-new"}
            handlePageSize={this.handlePageSize}
          />
        </div>

        {/* Tooltips for icons in table, don't delete */}
        {this.state.rowData.map(data => {
          return (
            <>
              <CustomReactTooltip
                id={`tooltip-${Slugify(
                  constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.EDIT_METRIC_TYPE_TOOLTIP,
                )}-${data.id}`}
                multiline={true}
              />
              <CustomReactTooltip
                id={`tooltip-${Slugify(
                  constants.APPLICATION_ROUTE.MASTER_DATA_METRIC_TYPE.LIST.MANAGE_METRICS_TOOLTIP,
                )}-${data.id}`}
                multiline={true}
              />
            </>
          );
        })}
        {/* <ManageMasterData
          documentModal={this.state.documentModal}
          closeDocumentModal={this.closeDocumentModal}
          masterName={this.state.metricType}
          addMasterData={this.handleSubmit}
          title={"Metric Type"}
          header={`${this.state.id ? "Edit" : "Add"} Metric Type`}
        /> */}
        <Modal
          isOpen={this.state.documentModal}
          toggle={() => {
            this.closeDocumentModal();
          }}
          className={"modal-sm modal-w-header custom-modal modal-without-header primary-modal"}
        >
          <ModalHeader
            toggle={() => {
              this.closeDocumentModal();
            }}
          >
            <div className="modal-header">
              <h3 className="text-darkblue2 font-weight-bold"> {this.state.id ? "Edit" : "Add"} Metric Type</h3>
            </div>
          </ModalHeader>
          <ModalBody style={{ paddingTop: "20px !important" }}>
            <div className={"row"}>
              <div className="col-sm-12 form-group position-relative m-auto">
                <label for="master-name mb-0">
                  Metric Type <span className={"mandatory"}>* </span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    this.state.formErrors.metricTypeError === true ? "is-invalid" : ""
                  } ${this.state.formErrors.metricTypeError === false ? "" : ""}`}
                  id="master-name"
                  placeholder={"Metric Type"}
                  value={this.state.metricType}
                  onChange={e => this.setState({ metricType: e.target.value })}
                />
                {this.state.formErrors.metricTypeError && (
                  <div className="invalid-tooltip d-block">{constants.FORM.MANDATORY_FIELD}</div>
                )}
              </div>
              <div className="col-sm-12 form-group position-relative mt-2">
                <label for="master-name mb-0">Metric Type Priority</label>
                <input
                  type="number"
                  className={`form-control`}
                  id="master-name"
                  min={1}
                  max={100}
                  placeholder={"Metric Type Priority"}
                  value={this.state.metricTypePriority}
                  onChange={e => {
                    this.setState({ metricTypePriority: e.target.value });
                  }}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="status-model-footer" style={{ justifyContent: "center !important" }}>
            <Button
              className={"btn-outline-primary modal-btn"}
              onClick={() => {
                this.closeDocumentModal();
              }}
            >
              Cancel
            </Button>{" "}
            <Button className={"modal-right-btn modal-btn"} type="submit" onClick={this.handleSubmit}>
              Save
            </Button>
          </ModalFooter>
        </Modal>
        <DialogNew
          isOpen={this.state.dialogModal}
          accept={this.dialogModalAccept}
          decline={this.dialogModalDecline}
          header={this.state.dialogModalHeader}
          content={this.state.dialogModalContent}
          config={this.state.dialogModalConfig}
          modalStyleType={this.state.dialogModalStyleType}
        />
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    home: state.home,
  };
};

export default connect(mapStateToProps, null)(ListMetricTypes);
